import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-occupancy-chart',
  templateUrl: './occupancy-chart.component.html',
  styleUrls: ['../common-dashboard/common-dashboard.component.scss']
})
export class OccupancyChartComponent {
  @Input() parkingLotsData: any;
  @Input() chartOptions: any;
  @Input() year;
  @Input() selectedYear;
}
